import pointerHome from '../../assets/icons/pointer-home.svg';

const problemsIT = [
  {
    icon: pointerHome,
    text: 'Ручное ведение релиза из-за непредсказуемости поведения связанных систем'
  },
  {
    icon: pointerHome,
    text: 'Сложный поиск точки отказа при интеграциях: каждый отдельный компонент системы работает, а сквозной процесс — нет'
  },
  {
    icon: pointerHome,
    text: 'Отсутствие превентивного оповещения при возникновении проблем во время релизов'
  },{
    icon: pointerHome,
    text: 'Неэффективное управление инфраструктурой, в т.ч. облачной'
  },{
    icon: pointerHome,
    text: 'Крупные инвестиции в инфраструктуру без явного эффекта'
  },{
    icon: pointerHome,
    text: 'Неэффективное управление бюджетом и штатом'
  },{
    icon: pointerHome,
    text: 'Низкая скорость внедрения изменений'
  }
]

const problemsBusiness = [
  {
    icon: pointerHome,
    text: 'Высокая численность ИТ-специалистов при неоднозначном эффекте'
  },
  {
    icon: pointerHome,
    text: 'Неполные регламенты процессов: узкие места процессов непрозрачны'
  },
  {
    icon: pointerHome,
    text: 'Отсутствие реальной карты процессов'
  },{
    icon: pointerHome,
    text: 'Отсутствие аналитики и рекомендаций по оптимизации процессов'
  },{
    icon: pointerHome,
    text: 'Сложность мониторинга «чужого» кода — программ, реализованных подрядчиком / командой разработки, которая более не в штате'
  }
]
export default function HomeSolutionIT() {
  return (
    <div className="w-full max-w-full xl:w-[1440px] flex justify-center">
      
      <div className="flex flex-col items-start lg:items-center gap-4 lg:gap-10">
        
        <div className="lg:text-center leading-normal text-[20px] lg:text-[32px] lg:leading-[44.8px] font-bold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text mt-[55px] px-4">
          Ключ-Астром решает:
        </div>


        <div className="w-full lg:w-[613.79px] h-auto lg:h-[40.50px] relative lg:mt-[-20px]">
          {/*  */}
          <div className="w-full lg:w-[7.50px] h-auto lg:h-[7.50px] left-[-3.50px] top-0 lg:top-[77px] absolute bg-[#d3aa86] rounded-full" />

          <div className="w-full lg:w-[7.50px] h-auto lg:h-[7.50px] left-0 lg:left-[597.50px] top-0 lg:top-[77px] absolute bg-[#d3aa86] rounded-full" />
          <div className="w-full lg:w-[11.79px] h-auto lg:h-[11.79px] left-0 lg:left-[294.50px] top-[-6px] absolute bg-[#d3aa86] rounded-full" />
          <div className="absolute left-0 lg:left-[0px] top-0 lg:top-[40px] w-full lg:w-[601px] h-auto lg:h-[1px] bg-[#d3aa86]" />
          <div className="absolute left-0 lg:left-[300.395px] top-0 lg:top-[5.79px] w-full lg:w-[1px] h-auto lg:h-[35px] bg-[#d3aa86]" />
          <div className="absolute left-0 lg:left-[0px] top-0 lg:top-[40px] w-full lg:w-[1px] h-auto lg:h-[37px] bg-[#d3aa86]" />
          <div className="absolute left-0 lg:left-[601.25px] top-0 lg:top-[40px] w-full lg:w-[1px] h-auto lg:h-[37px] bg-[#d3aa86]" />
        </div>

        <div className="flex flex-col lg:flex-row justify-between lg:mt-[38px] mb-[120px] lg:mb-[30px]">
          <div className="flex flex-col gap-4 w-full max-w-[597px] xl:w-[597px] lg:mt-[0px] lg:items-center">

            <div className="w-full h-auto lg:h-[33px] lg-text-left xl:text-center flex items-center pl-[5px]">
              <div className="w-[38px]">
                <img src={pointerHome} alt="" className="w-[38px] lg:hidden" />
              </div>
              <div className="text-[#d3aa86] text-[16px] lg:text-2xl font-bold font-['Open Sans'] pl-[3px] w-full xl:text-center">
                Проблемы ИТ
              </div>
            </div>

            <ul className="space-y-4 px-0">
              {problemsIT.map((problem, index) => (
                <SolutionFeature
                  key={index}
                  index={index}
                  icon={problem.icon}
                  text={problem.text}
                />
              ))}
            </ul>
          </div>
          <div className="flex flex-col gap-4 w-full max-w-[597px] xl:w-[597px] mt-[60px] lg:mt-[0px] lg:items-center">

            <div className="w-full h-auto lg:h-[33px] lg:text-right xl:text-center flex items-center pl-[5px]">
              <div className="w-[38px]">
                <img src={pointerHome} alt="" className="w-[38px] lg:hidden" />
              </div>
              <div className="text-[#d3aa86] text-[16px] lg:text-2xl font-bold font-['Open Sans'] pl-[3px] w-full lg:text-center">
              Проблемы бизнеса
              </div>
            </div>
            <ul className="space-y-4 px-0">
              {problemsBusiness.map((problem, index) => (
                <SolutionFeature
                  key={index}
                  index={index}
                  icon={problem.icon}
                  text={problem.text}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

function SolutionFeature({ index, icon, text }) {
  return (
    <div className="flex items-start gap-[10px]">
      {index == 0 ?
        <div className="w-[38px]">
          <img src={icon} alt="" className="w-[38px] hidden lg:block" />
        </div>:
        <div className="w-[38px]"></div>
        }
        <div className="w-[270px] md:w-[290px] lg:w-[360px] xl:w-[529px] text-[#544A28] text-[16px]">
          {text}
        </div>      
    </div>
  );
} 